import React from 'react';
import { Modal, Button } from '../ui';
import GroupInviteLinkActions from './GroupInviteLinkActions';
import { zIndex } from '../../design-system/tokens';

export default function LeagueCreatedSuccessModal({
  open,
  groupId,
  groupName,
  onGoToLeague,
}) {
  if (!open || !groupId) return null;

  return (
    <Modal
      open={open}
      accent="admin"
      size="md"
      z={zIndex.modal + 2}
      panelClassName="border-2 border-violet-500/40 shadow-[0_24px_80px_rgba(139,92,246,0.25)]"
      bodyClassName="p-6 sm:p-8"
    >
      <div className="text-center">
        <p className="text-4xl mb-3" aria-hidden>🏆</p>
        <h2 id="league-created-title" className="text-2xl font-black text-white">
          League Created
        </h2>
        <p className="text-sm text-gray-400 mt-2 font-medium leading-relaxed">
          Next step: invite your first member
        </p>
        {groupName && (
          <p className="text-xs text-violet-300 font-bold mt-3 uppercase tracking-widest">
            {groupName}
          </p>
        )}
        <div className="mt-6">
          <GroupInviteLinkActions
            groupId={groupId}
            groupName={groupName}
            layout="column"
          />
        </div>
        <Button
          type="button"
          variant="ghost"
          fullWidth
          className="mt-4"
          onClick={() => onGoToLeague?.(groupId)}
        >
          Go to league
        </Button>
      </div>
    </Modal>
  );
}
